import { all } from "axios";

export function* rootSaga() {
    yield all([])
}